import {FC, useState, useEffect, Fragment} from 'react'

type Props = {
  endDate: string
  serverTime: string
}

const CountDownContent: FC<Props> = ({endDate, serverTime}) => {
  const [targetDate, setTargetDate] = useState<string>(endDate)
  const [timeLeft, setTimeLeft] = useState<any>({})

  useEffect(() => {
    updateCountdown() // jalankan pertama kali
    const timer = setInterval(updateCountdown, 1000) // perbarui setiap detik

    return () => clearInterval(timer) // bersihkan saat unmount
  }, [targetDate])

  const updateCountdown = () => {
    const now = new Date()

    const timeServer = serverTime ? new Date(serverTime) : now

    const difference = new Date(targetDate ?? now).getTime() - timeServer.getTime()

    if (difference <= 0) {
      setTimeLeft({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      })
      return
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24))
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24)
    const minutes = Math.floor((difference / (1000 * 60)) % 60)
    const seconds = Math.floor((difference / 1000) % 60)

    setTimeLeft({days, hours, minutes, seconds})
  }

  return (
    <div className='mb-8 p-4 bg-white rounded text-black d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3'>
      <p className='fw-bold mb-0'>Deadline Submit Pendaftaran:</p>

      <div className='d-flex gap-2 flex-wrap justify-content-center'>
        <span
          className='p-2 text-white px-3'
          style={{borderRadius: '8px', background: '#F15C59', fontWeight: '700'}}
        >
          {String(timeLeft.days).padStart(2, '0')} hari
        </span>
        <span
          className='my-2 fw-bold'
          style={{borderRadius: '8px', color: '#F15C59', fontWeight: '700'}}
        >
          :
        </span>

        <span
          className='p-2 text-white px-3'
          style={{borderRadius: '8px', background: '#F15C59', fontWeight: '700'}}
        >
          {String(timeLeft.hours).padStart(2, '0')} jam
        </span>
        <span
          className='my-2 fw-bold'
          style={{borderRadius: '8px', color: '#F15C59', fontWeight: '700'}}
        >
          :
        </span>

        <span
          className='p-2 text-white px-3'
          style={{borderRadius: '8px', background: '#F15C59', fontWeight: '700'}}
        >
          {String(timeLeft.minutes).padStart(2, '0')} menit
        </span>
        <span
          className='my-2 fw-bold'
          style={{borderRadius: '8px', color: '#F15C59', fontWeight: '700'}}
        >
          :
        </span>

        <span
          className='p-2 text-white px-3'
          style={{borderRadius: '8px', background: '#F15C59', fontWeight: '700'}}
        >
          {String(timeLeft.seconds).padStart(2, '0')} detik
        </span>
      </div>
    </div>
  )
}

const CountDown: FC<Props> = ({endDate, serverTime}) => {
  return <CountDownContent endDate={endDate} serverTime={serverTime} />
}

export default CountDown
